import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative flex flex-wrap items-center justify-between px-2 py-5 bg-dark shadow-md" }
const _hoisted_2 = { class: "container px-4 mx-auto flex flex-wrap items-center justify-between" }
const _hoisted_3 = { class: "w-full relative flex justify-between lg:w-auto px-4 lg:static lg:block lg:justify-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", { class: "text-xl font-brand leading-relaxed inline-block mr-4 py-2 whitespace-nowrap text-white" }, " SubOptimal Timer ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-col lg:flex-row list-none ml-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "px-3 py-2 flex items-center text-xs uppercase font-bold leading-snug text-white hover:bg-bgDark transition duration-150 rounded",
    href: "https://github.com/infraredCoding/suboptimal-timer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-github text-lg leading-lg text-white opacity-75" }),
    /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Star")
  ])
], -1)
const _hoisted_9 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_10 = { class: "px-4 py-3 flex items-center text-sm font-bold leading-snug text-white hover:bg-bgDark transition duration-150 rounded" }
const _hoisted_11 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_12 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_13 = {
  key: 3,
  class: "nav-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleNavbar()))
        }, _hoisted_6)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{'hidden': !_ctx.showMenu, 'flex': _ctx.showMenu}, "lg:flex lg:flex-grow items-center transition duration-150"])
      }, [
        _createElementVNode("ul", _hoisted_7, [
          _hoisted_8,
          (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.getUsername), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.logoutUser()), ["prevent"])),
                  class: "px-4 py-3 flex items-center text-sm uppercase font-bold leading-snug text-white hover:bg-bgDark transition duration-150 rounded"
                }, " Logout ")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.ToggleAuthLoginModal()), ["prevent"])),
                  class: "px-4 py-3 flex items-center text-sm uppercase font-bold leading-snug text-white hover:bg-bgDark transition duration-150 rounded"
                }, " Login ")
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loggedIn)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.ToggleAuthRegisterModal()), ["prevent"])),
                  class: "btn bg-primary mx-3 flex items-center text-sm uppercase font-bold leading-snug text-white transition duration-150 hover:opacity-75"
                }, " Signup ")
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}